var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"wrapper",attrs:{"data-app":""}},[_c('Header'),_c('article',{staticClass:"content w-100"},[_c('MenuBar',{attrs:{"global_route":this.$route.name}}),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }